const FIGURE = {};

FIGURE.init = (function() {
	const $body = $("body");
	//Mobile Detection
	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	if (isMobile) {
		$body.addClass("mobile-device");
	}
	//Headroom
	$body.headroom({ offset: 100 });

	//Footer measurer
	// const scaleFooter = function() {
	// 	const theFooterHeight = $(".site-footer").outerHeight();
	// 	const $bottomBorder = $(".bottom-border");
	// 	let bottomBorderHeight;
	// 	if ($bottomBorder.length) {
	// 		bottomBorderHeight = $bottomBorder.height();
	// 	}
	// 	else {
	// 		bottomBorderHeight = 20;
	// 	}
	// 	//$("body").css("padding-bottom", theFooterHeight + bottomBorderHeight);
	// 	//$(".site-footer").addClass("loaded");
	// 	$(".site-modal").css("margin-bottom", "0");
	// };
	// $(window).resize(function() {
	//   scaleFooter();
	// });
	// $(window).on('load', function () {
	//  scaleFooter();
	// });

	$(".system-messages").slideDown();
	//Tooltips
	$('[data-toggle="tooltip"]').tooltip();
	$('[data-toggle="popover"]')
		.popover()
		.addClass("pointer");
	return true;
})();

FIGURE.loginReminder = (function() {
	const cookieValueSuper = $.cookie("loginReminder");
	if (cookieValueSuper === "reminded") {
		return;
	}
	else {
		setTimeout(function() {
			$(".login-reminder").fadeIn();
		}, 3000);
		setTimeout(function() {
			$(".login-reminder").addClass("loaded");
		}, 3500);
		setTimeout(function() {
			$(".login-reminder").fadeOut();
		}, 11000);
		$.cookie("loginReminder", "reminded", { expires: 1, path: "/" });
	}

	return true;
})();

FIGURE.adaCollapse = (function() {
	$(".btn[data-toggle=\"collapse\"]").keyup(function() {
		const toExpand = $(this).attr("href");
		$(toExpand).addClass("show");
	});

	return true;
})();

FIGURE.modaler = (function() {
	$(document).on("show.bs.modal", ".ajaxmodal", function(e) {
		const button = $(e.relatedTarget);
		const modalContent = button.attr("href");
		const target = button.attr("data-target");
		$(`${target} .modal-load-area`).load(`${modalContent}?pagetype=modal`, function() {
			if ($(this).find(".needs-validation").length) {
				FIGURE.validateForm(`${target} .modal-load-area`);
			}
		});
	});
	$(document).on("shown.bs.modal", ".ajaxmodal", function(e) {
		const button = $(e.relatedTarget);
		const theRedirect = button.attr("data-redirect");
		if (theRedirect !== "") {
			$("#redirectField").val(theRedirect);
		}
	});
	$(document).on("hide.bs.modal", ".ajaxmodal", function() {
		$(".modal-load-area").html("");
		setTimeout(() => {
			const $modalBackdropFade = $(".modal-backdrop.fade");
			if ($modalBackdropFade.length) {
				$modalBackdropFade.remove();
			}
		}, 500);
	});

	return true;
})();

FIGURE.openModal = (function() {
	$(document).on("click", ".modal-trigger", function() {
		const $this = $(this);
		const theContent = $this.attr("href");
		const modalSize = $this.attr("data-modal-size");
		const $siteModal = $(".site-modal");
		const $siteModalContent = $(".site-modal-content");

		$siteModal.attr("class", `site-modal ${modalSize}`);
		$siteModal.focus();
		$siteModal
			.removeAttr("aria-hidden")
			.removeAttr("tabindex");
		if ($this.hasClass("inline-modal")) {
			const inlineContent = $(theContent).html();
			$siteModalContent.html("");
			$siteModalContent.html(inlineContent);
			setTimeout(function() {
				$siteModal.scrollTop(0);
			}, 20);
		}
		else {
			$siteModalContent.load(`${theContent}?pagetype=modal`);
		}
		$("body")
			.addClass("modal-open")
			.addClass("modal-on-page");
		$(".site-mask").fadeIn();
		return false;
	});
	$(document).on(
		"click",
		".modal-close, .modal-close-generic, .page-mask, .modal-mask",
		function() {
			const $siteModal = $(".site-modal");
			const $siteModalContent = $(".site-modal-content");

			$("body").removeClass("modal-open");
			$(".site-mask").fadeOut();
			$siteModal
				.attr("aria-hidden", "true")
				.attr("tabindex", "-1");
			setTimeout(function() {
				$("body").removeClass("modal-on-page");
				$siteModal.attr("class", "site-modal");
				$siteModalContent.html("");
			}, 500);
			return false;
		}
	);
	return true;
})();

FIGURE.noDoubleClick = (function() {
	$(".btn-no-double").click(function() {
		setTimeout(function() {
			$(".btn-no-double")
				.attr("disabled", "disabled")
				.val("processing")
				.text("processing");
		}, 100);
	});

	return true;
})();

FIGURE.openNav = (function() {
	const $body = $("body");
	const $navMask = $(".nav-mask");
	const $siteNav = $(".site-nav");
	const $openNav = $(".open-nav");
	const mainContentSelector = "#maincontent a, #maincontent button, .site-footer a, .site-footer button, .site-logo, .account-links a, .skip-link";

	$(document).on("click", ".open-nav", function() {
		if (!$(this).hasClass("disabled")) {
			if ($body.hasClass("nav-open")) {
				$body.removeClass("nav-open");
				$navMask.fadeOut();
				setTimeout(function() {
					$body.removeClass("nav-on-page");
				}, 500);
				$siteNav
					.attr("aria-hidden", "true")
					.attr("tabindex", "-1");
				$(mainContentSelector)
					.removeAttr("aria-hidden")
					.removeAttr("tabindex");
				$openNav.attr("aria-expanded", "false");
			}
			else {
				$body.addClass("nav-on-page");
				setTimeout(function() {
					$body.addClass("nav-open");
				}, 50);
				$navMask.fadeIn();
				$siteNav
					.removeAttr("aria-hidden")
					.removeAttr("tabindex");
				$(mainContentSelector)
					.attr("aria-hidden", "true")
					.attr("tabindex", "-1");
				$openNav.attr("aria-expanded", "true");
			}
			return false;
		}
	});
	$(document).on("click", ".nav-mask", function() {
		$body.removeClass("nav-open");
		$navMask.fadeOut();
		setTimeout(function() {
			$body.removeClass("nav-on-page");
		}, 500);
		$siteNav
			.attr("aria-hidden", "true")
			.attr("tabindex", "-1");
		$(mainContentSelector)
			.removeAttr("aria-hidden")
			.removeAttr("tabindex");
		$openNav.attr("aria-expanded", "false");
	});

	return true;
})();

FIGURE.singlepageBehavior = (function() {
	$(document).on("click", ".single-page .site-nav a", function() {
		const $body = $("body");
		$body.removeClass("nav-open");
		$(".nav-mask").fadeOut();
		setTimeout(function() {
			$body.removeClass("nav-on-page");
		}, 500);
		if (
			location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "")
			&& location.hostname === this.hostname
		) {
			let target = $(this.hash);
			target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
			if (target.length) {
				$("html,body").animate(
					{
						scrollTop: target.offset().top //-200
					},
					1000
				);
			}
		}
	});

	return true;
})();

FIGURE.openNavID = (function() {
	const $body = $("body");

	$(document).on("click", "#opennav", function() {
		if (!$(this).hasClass("disabled")) {
			if ($body.hasClass("nav-open")) {
				$body.removeClass("nav-open");
				setTimeout(function() {
					$body.removeClass("nav-on-page");
				}, 500);
			}
			else {
				$body
					.addClass("nav-open")
					.addClass("nav-on-page");
			}
			return false;
		}
	});
	$(document).on("click", ".nav-open #opennav", function() {
		$body.removeClass("nav-open");
		setTimeout(function() {
			$body.removeClass("nav-on-page");
		}, 500);
	});

	return true;
})();

FIGURE.closeEverything = (function() {
	$(document).keyup(function(e) {
		if (e.keyCode === 27) {
			const $body = $("body");
			const $siteModal = $(".site-modal");
			const $siteModalContent = $(".site-modal-content");
			const $siteNav = $(".site-nav");
			const mainContentSelector = "#maincontent a, #maincontent button, .site-footer a, .site-footer button, .site-logo, .account-links a, .skip-link";

			$body.removeClass("nav-open");
			$(".site-mask").fadeOut();
			$(".nevermiss-modal").fadeOut();
			$(".nav-mask").fadeOut();
			$siteNav
				.attr("aria-hidden", "true")
				.attr("tabindex", "-1");
			$siteModal
				.attr("aria-hidden", "true")
				.attr("tabindex", "-1");
			$(mainContentSelector)
				.removeAttr("aria-hidden")
				.removeAttr("tabindex");
			$(".open-nav").attr("aria-expanded", "false");
			setTimeout(function() {
				$body.removeClass("nav-on-page");
			}, 500);
			$body.removeClass("modal-open");
			setTimeout(function() {
				$body.removeClass("modal-on-page");
				$siteModal.attr("class", "site-modal");
				$siteModalContent.html("");
			}, 500);
		}
	});

	return true;
})();

FIGURE.banners = (function() {
	$(document).on("click", ".show-top-promo", function() {
		$("body").toggleClass("promo-open");
		return false;
	});

	return true;
})();

FIGURE.textSwap = (function() {
	$(document).on("click", ".btn-swap-text", function() {
		const $this = $(this);
		const newText = $this.attr("data-new-text");
		const originalText = $this.attr("data-original-text");
		if ($this.hasClass("activated")) {
			$this.text(originalText);
			$this
				.removeClass("activated")
				.addClass("killscroll");
		}
		else {
			$this.text(newText);
			$this
				.addClass("activated")
				.removeClass("killscroll");
		}
	});

	return true;
})();

FIGURE.validateForm = (function() {
	"use strict";

	function validateForm(selector) {
		const root = selector
			? document.querySelector(selector)
			: document;

		if (!root) {
			return;
		}

		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		const forms = root.getElementsByClassName("needs-validation");
		// Loop over them and prevent submission
		Array.prototype.filter.call(forms, function(form) {
			if (form.dataset.validationEventAdded === "true") {
				return;
			}

			form.dataset.validationEventAdded = "true";
			form.addEventListener(
				"submit",
				function(event) {
					if (form.checkValidity() === false) {
						event.preventDefault();
						event.stopPropagation();
						$(".needs-validation").addClass("not-yet-sparky");
					}
					else {
						$(".needs-validation").removeClass("not-yet-sparky");
					}
					form.classList.add("was-validated");
				},
				false
			);
		});
	}

	window.addEventListener(
		"load",
		function() {
			validateForm();
		},
		false
	);

	return validateForm;
})();

// .trim-text for text inputs
/**
* Adding by Zachary Stovall on 04-10-2024
* This is to remove any white space from the beginning and end of the input field
* Designed for Quilceda Creek home page but can be used anywhere by adding the trim-text tag
*
* */
FIGURE.trimText = (function() {
	$(document).on("blur", ".trim-text", function() {
		const $this = $(this);
		const trimText = $this.val().trim();
		$this.val(trimText);
	});

	return true;
})();

FIGURE.validateEmail = (function() {
	$(document).on("blur", ".validate-email", function() {
		const $this = $(this);
		const sEmail = $this.val();
		const $formGroup = $this.parents(".form-group");
		const $form = $this.parents("form");

		if (validateEmail(sEmail)) {
			$formGroup.removeClass("form-error");
			$form
				.find("button[type=submit]")
				.removeAttr("disabled");
			if (!$("#validEmail").length) {
				$formGroup.append(
					'<div class="positive-feedback" id="validEmail">Email is valid</div>'
				);
			}
		}
		else {
			$formGroup.addClass("form-error");
			$form
				.find("button[type=submit]")
				.attr("disabled", "disabled");
			$formGroup
				.find("#validEmail")
				.remove();
		}
	});
	function validateEmail(sEmail) {
		const filter = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		return filter.test(sEmail);
	}

	return true;
})();

// FIGURE.smartyStreets = function() {
// 	//Smarty Streets
// 	const htmlKey = '1189143399195047'
//
// 	const ss = jQuery.LiveAddress({
// 		autocomplete: 5,
// 		key: htmlKey,
// 		missingInputMessage: "Not enough input<br>",
// 		certifyMessage: "Use my address",
// 		verifySecondary: true,
// 		waitForStreet: true,
// 		debug: false,
// 		target: "US|INTERNATIONAL",
// 		addresses: [{
// 			address1: "#address",
// 			address2: "#address2",
// 			locality: "#city",
// 			administrative_area: "#state",
// 			postal_code: "#zip",
// 			country: "#country"
// 		}],
// 		agent: "website:plugin-demo@latest|"
// 	});
// }();

/*FIGURE.euroCookie = (function() {
	const defaultButtonTxt = $("#cookie_accept").text();
	$("#cookie_enable").change(function() {
		if (this.checked) {
			$("#cookie_accept")
				.addClass("die-cookie")
				.removeClass("disabled")
				.removeClass("btn-outline-primary")
				.addClass("btn-primary")
				.text("Accept & Close");
		}
		else {
			$("#cookie_accept")
				.removeClass("die-cookie")
				.addClass("disabled")
				.addClass("btn-outline-primary")
				.removeClass("btn-primary")
				.text(defaultButtonTxt);
		}
	});

	$(document).on("click", ".die-cookie", function() {
		$.cookie("euroWarning", "nomnomnom", { expires: 1825, path: "/" });
		$("#euroCookie").fadeOut();
		$('body').removeClass('no-cookie');
		return false;
	});
	const cookieValue = $.cookie("euroWarning");
	if (cookieValue === "nomnomnom") {
		return;
	}
	else {
		$("#euroCookie").fadeIn();
		$('body').addClass('no-cookie');
	}
})();*/

FIGURE.stuck = (function() {
	$(window).stuck();
	$(document).ready(function() {
		//stuck
		$(window).stuck();
		$(window).scroll(function() {
			$(".super-stuck").each(function() {
				const $this = $(this);
				if ($this.css("position") === "fixed") {
					$this.addClass("show-more");
				}
				else {
					$this.removeClass("show-more");
				}
			});
		});
	});

	return true;
})();

FIGURE.cartCount = (function() {
	// cart count
	const doCartCount = function() {
		$.getJSON("/cart/item-count.json", function(data) {
			const $cartLink = $(".cart-link");
			const $face = $(".face");

			if (data > 0) {
				$("#cartcount").html(
					` <span class="badge badge-pill badge-primary">${data}</span>`
				);
				$("#cartcountnav").html(
					` <span class="badge badge-pill badge-primary">${data}</span>`
				);
				$cartLink.removeClass("hide-cart");
				$face.addClass("happy");
				$cartLink.attr("href", "/cart/");
			}
			else {
				$("#cartcount").html("");
				$("#cartcountnav").html("");
				$cartLink.addClass("hide-cart");
				$face.removeClass("happy");
			}
			$face.addClass("show");
		});
	};
	if ($(".cart-link").hasClass("check-cart")) {
		doCartCount();
	}

	return true;
})();

FIGURE.refer = (function() {
	$(".refer-radio").change(function() {
		const $this = $(this);
		const textInput = $this.attr("data-the-text");
		if ($this.is(":checked")) {
			$(".referrer-text")
				.removeClass("current")
				.addClass("d-none")
				.val("")
				.attr("disabled", "disabled");
			$(textInput)
				.addClass("current")
				.removeClass("d-none")
				.focus()
				.removeAttr("disabled");
		}
	});

	return true;
})();

FIGURE.scrollTo = (function() {
	$(document).on("click", ".scrollto", function(e) {
		e.preventDefault(); // Prevent default immediately

		const $clickedElement = $(this); // Store 'this' reference
		const $target = $(e.target).closest(".scrollto");
		const delay = $target.data('delay') || 0;

		if (!$target.hasClass("killscroll")) {
			setTimeout(() => {
				const animationLength = 1000;
				const hash = $clickedElement.attr("href");
				const scrollOffset = parseInt($clickedElement.attr("data-offset")) || 0;

				// Check if same page
				if (
					location.pathname.replace(/^\//, "") == $clickedElement[0].pathname.replace(/^\//, "")
					&& location.hostname == $clickedElement[0].hostname
				) {
					const $scrollTarget = $(hash);

					if ($scrollTarget.length) {
						const theScroll = $scrollTarget.offset().top - scrollOffset;
						$("html, body").animate({ scrollTop: theScroll }, animationLength);
					}
				}

				const $body = $("body");
				// For mobile nav sign up when on sign up page
				if ($target.closest(".mobile-nav-links").length) {
					const $siteHeader = $(".site-header");
					$siteHeader.find(".open-nav").attr("aria-expanded", "false");

					const $siteNav = $siteHeader.find(".site-nav");
					$siteNav.attr("aria-hidden", "true");
					$siteNav.attr("tabindex", "-1");
					$body.removeClass("nav-on-page nav-open");
					$(".nav-mask").css("display", "");
				}

				if ($target.closest(".site-header").length) {
					setTimeout(() => {
						$body.removeClass("headroom--unpinned");
						$body.addClass("headroom--pinned");
					}, animationLength + 50);
				}
			}, delay);

			return false;
		}
	});
})();

FIGURE.scrollToTrade = (function() {
	$(document).on("click", ".scrolltotrade", function() {
		if (
			location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "")
			&& location.hostname === this.hostname
		) {
			let target = $(this.hash);
			const scrollOffset = $(this).attr("data-offset");
			target = target.length
				? target
				: $(`[name=${this.hash.slice(1)}]`);
			let theScroll;
			if (scrollOffset > 0) {
				theScroll = target.offset().top - scrollOffset;
			}
			else {
				theScroll = target.offset().top;
			}
			if (target.length) {
				$("html,body").animate(
					{
						scrollTop: theScroll
					},
					1000
				);
			}
		}
	});
	$(window).scroll(function() {
		$(".trade-section").each(function() {
			const $this = $(this);
			if ($this.is(":in-viewport(500)")) {
				const theNav = $this.attr("data-nav");
				$(".trade-nav a").removeClass("active");
				$(theNav).addClass("active");
			}
		});
	});

	return true;
})();

FIGURE.formMonkey = (function() {
	// Object of Countries that don't have Postal Code
	const noPostalCode = {
		AO: true, AG: true, AW: true, AC: true, BS: true, BZ: true, BJ: true,
		BO: true, BQ: true, BW: true, BF: true, BI: true, CM: true, CF: true,
		KM: true, CG: true, CD: true, CK: true, CI: true, CW: true, DJ: true,
		DM: true, TL: true, GQ: true, ER: true, FJ: true, TF: true, GA: true,
		GM: true, GH: true, GD: true, GY: true, HM: true, HK: true, KI: true,
		LY: true, MO: true, MW: true, ML: true, MR: true, NR: true, AN: true,
		NU: true, KP: true, QA: true, RW: true, KN: true, ST: true, SC: true,
		SL: true, SB: true, SR: true, SY: true, TG: true, TK: true, TO: true,
		TV: true, UG: true, AE: true, VU: true, YE: true, ZW: true
	};

	// Template function for Address Form
	function handleCountrySelect(countryCode) {
		const $stateText = $(".state-text");
		const $stateSelect = $(".state-select");
		const $zipCol = $(".zip-col");
		const $zip = $("#zip");

		//Removes state dropdown if not MURCA!
		if (countryCode === "US") {
			$(".murca").show();
			$(".not-murca").hide();
			$stateText
				.hide()
				.removeAttr("required")
				.attr("id", "nothing")
				.attr("name", "nothing");
			$stateSelect
				.show()
				.attr("required", "true")
				.attr("id", "state")
				.attr("name", "data[state]");
		}
		else {
			$(".murca").hide();
			$(".not-murca").show();
			$stateSelect
				.hide()
				.removeAttr("required")
				.attr("id", "nothing")
				.attr("name", "nothing");
			$stateText
				.show()
				.attr("required", "true")
				.attr("id", "state")
				.attr("name", "data[state]");
		}
		//Removes zip code field from countries without a postal code
		if (noPostalCode[countryCode]) {
			$zipCol.hide();
			$zip.removeAttr("required");
		}
		else {
			$zipCol.show();
			$zip.attr("required", "true");
		}
	}

	// Checks for any input that contains id of country
	$(document).on("change", '[id*="country"]', function() {
		const thisVal = $(this).val();

		try {
			handleCountrySelect(thisVal);
			// Reset input fields
			$('[id*="company"]').val("");
			$('[id*="address"]').val("");
			$('[id*="city"]').val("");
			$('[id*="state"]').val("");
			$('[id*="zip"]').val("");
		} catch (e) {}
	});

	// On New Address
	$("a[href=\"#newaddress\"]").on("click", function() {
		const countryVal = $("#newaddress")
			.find("[id^=\"country\"]")
			.val();
		handleCountrySelect(countryVal);
	});

	$(document).ready(function() {
		// On page load, if a country field exists, and a non-US country is selected, hide the state dropdown
		const countryVal = $('[id*="country"]').val();
		if (countryVal && countryVal !== "US") {
			handleCountrySelect(countryVal);
		}

		// On Modal open check for default values
		$('[id*="figureModal"]').on("shown.bs.modal", function(e) {
			$(document).ajaxComplete(function() {
				try {
					const countryVal = $(`#${e.target.id}`)
						.find('[id^="country"]')
						.val();
					if (!countryVal) return;
					handleCountrySelect(countryVal);
				} catch (e) {}
			});
		});
	});

	return true;
})();

FIGURE.modularForm = (function() {
	$(".modular-form-fields .interest-radio").change(function() {
		const $requireMe = $(".require-me");
		const $extendedForm = $(".modular-form-fields .extended-form");
		const $defaultForm = $(".modular-form-fields .default-form");

		if ($(".modular-form-fields .interest-radio.show-everything").is(":checked")) {
			$(".swap-text .alt-text").hide();
			$(".swap-text .default-text").show();
			$requireMe.removeAttr("required");
			$extendedForm
				.hide()
				.show();
			$defaultForm
				.hide()
				.show();
			$requireMe.attr("required", "required");
		}
		if ($(".modular-form-fields .interest-radio.show-default").is(":checked")) {
			$(".swap-text .default-text").hide();
			$(".swap-text .alt-text").show();
			$requireMe.removeAttr("required");
			$extendedForm.hide();
			$defaultForm
				.hide()
				.show();
			$(".default-form .require-me").attr("required", "required");
			$(".first-name-copy").val("");
			$(".last-name-copy").val("");
			$(".email-copy").val("");
			$("#copyinfo").prop("checked", false);
		}
	});
	$("#copyinfo").change(function() {
		if ($(this).is(":checked")) {
			const firstname = $(".first-name-base").val();
			$(".first-name-copy").val(firstname);
			const lastname = $(".last-name-base").val();
			$(".last-name-copy").val(lastname);
			const email = $(".email-base").val();
			$(".email-copy").val(email);
		}
		else {
			$(".first-name-copy").val("");
			$(".last-name-copy").val("");
			$(".email-copy").val("");
		}
	});

	return true;
})();

FIGURE.refer = (function() {
	if (window.location.hash) {
		const hash = window.location.hash.substr(1);
		$("#referral_note").val(hash);
	}

	return true;
})();

FIGURE.owlHack = (function() {
	setTimeout(function() {
		$(".owl-dot").each(function() {
			const $this = $(this);
			$this.attr("aria-label", "advance to next pane");
		});
	}, 3000);

	return true;
})();

FIGURE.styleGuideColor = function() {
	$(".style-color").each((i, el) => {
		const color = $(el).css("background-color");
		const hexer = {
			0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9,
			10: "A", 11: "B", 12: "C", 13: "D", 14: "E", 15: "F"
		};
		const colorArr1 = color.split("(")[1];
		const colorArr2 = colorArr1.split(")")[0];
		const colorArr = colorArr2.split(",").map(color => color.trim());
		let hexColor = "#";
		for (let i = 0; i < 3; i++) {
			const colorHex = parseFloat(colorArr[i]) / 16;
			const colorHex1 = Math.floor(colorHex);
			let colorHex2 = 0;
			if (colorHex !== colorHex1) {
				colorHex2 = parseFloat(`.${(colorHex + "").split(".")[1]}`) * 16;
			}
			hexColor += hexer[colorHex1];
			hexColor += hexer[colorHex2];
		}
		$(el).siblings(".style-color-hex").text(hexColor);
	});

	return true;
}();

FIGURE.specialMessageModal = function () {
	const $figureMessageModal = $("#figureMessageModal");
	if ($figureMessageModal.length) {
		const specialMessageModal = $.cookie("specialmessage");
		if (specialMessageModal === "read") {
			return;
		}
		else {
			setTimeout(function () {
				$figureMessageModal.modal("show");
			}, 2000);
		}
		$(document).on("hide.bs.modal", "#figureMessageModal", function () {
			$.cookie("specialmessage", "read", { expires: 30, path: "/" });
		});
		$(document).on("click", "#figureMessageModal a", function () {
			$.cookie("specialmessage", "read", { expires: 30, path: "/" });
		});
		$(document).on("click", "#figureMessageModal button", function () {
			$.cookie("specialmessage", "read", { expires: 30, path: "/" });
		});
	}

	return true;
};

FIGURE.ageGateModal = function () {
	$(window).on("load", function () {
		const $offsetAgeGate = $("#offsetAgeGate");
		if ($offsetAgeGate.length) {
			const currentYear = new Date().getFullYear();
			const leapYears = [];
			for (let year = currentYear; year >= currentYear - 150; year--) {
				if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
					leapYears.push(year);
				}
			}
			const $verifyMonth = $("#verify-month");
			const $verifyDay = $("#verify-day");
			const $verifyYear = $("#verify-year");
			const age = {
				month: $verifyMonth.val(),
				day: $verifyDay.val(),
				year: $verifyYear.val()
			};

			if ($.cookie("ageGateCookie") !== "oldEnough") {
				if ($(".page-pages-styleguide").length === 0) {
					$offsetAgeGate.modal("show");
				}
				initAge();
			}
			else {
				FIGURE.specialMessageModal();
			}

			// starts the age verification process
			function initAge() {
				$verifyMonth.on("change", function (e) {
					const month = $(e.target);
					if (["4", "6", "9", "11"].includes(month.val())) {
						$verifyDay.find("option[value=\"31\"]").remove();
					}
					else if (month.val() === "2") {
						if (!leapYears.includes(parseFloat($verifyYear.val()))) {
							$verifyDay.find("option[value=\"29\"]").remove();
						}
						$verifyDay.find("option[value=\"30\"]").remove();
						$verifyDay.find("option[value=\"31\"]").remove();
					}
					else {
						if (!$verifyDay.find("option[value=\"29\"]").length) {
							$verifyDay.append("<option value=\"29\">29</option>");
						}
						if (!$verifyDay.find("option[value=\"30\"]").length) {
							$verifyDay.append("<option value=\"30\">30</option>");
						}
						if (!$verifyDay.find("option[value=\"31\"]").length) {
							$verifyDay.append("<option value=\"31\">31</option>");
						}
					}
					age.month = month.val();
				});
				$verifyYear.on("change", function (e) {
					const year = $(e.target);
					if (
						leapYears.includes(parseFloat(year.val()))
						&& $verifyMonth.val() === "2"
					) {
						if (!$verifyDay.find("option[value=\"29\"]").length) {
							$verifyDay.append("<option value=\"29\">29</option>");
						}
					}
					age.year = year.val();
				});
				$verifyDay.on("change", function (e) {
					age.day = $(e.target).val();
				});
				$("#js-age-submit").on("click", function () {
					age.month = $verifyMonth.val();
					age.day = $verifyDay.val();
					age.year = $verifyYear.val();
					checkDate();
				});
			}

			// Check to see if user entered a valid date...
			function checkDate() {
				if (age.month === "none" || age.day === "none" || age.year === "none") {
					// Fade in the error...
					$("#modal-error").css("visibility", "visible").hide().fadeIn("slow");

					// changes the background color of the select if invalid
					if (age.month === "none") {
						$verifyMonth.css("background", "rgba(223,32,44,0.5)");
						// Look for change of value and change background color when valid
						$verifyMonth.on("change", function () {
							if ($verifyMonth.val() === "none") {
								$verifyMonth.css("background", "rgba(223,32,44,0.5)");
							}
							else {
								$verifyMonth.css("background", "white");
							}
						});
					}

					// changes the background color of the select if invalid
					if (age.day === "none") {
						$verifyDay.css("background", "rgba(223,32,44,0.5)");
						// Look for change of value and change background color when valid
						$verifyDay.on("change", function () {
							if ($verifyDay.val() === "none") {
								$verifyDay.css("background", "rgba(223,32,44,0.5)");
							}
							else {
								$verifyDay.css("background", "white");
							}
						});
					}

					// changes the background color of the select if invalid
					if (age.year === "none") {
						$verifyYear.css("background", "rgba(223,32,44,0.5)");
						// Look for change of value and change background color when valid
						$verifyYear.on("change", function () {
							if ($verifyYear.val() === "none") {
								$verifyYear.css("background", "rgba(223,32,44,0.5)");
							}
							else {
								$verifyYear.css("background", "white");
							}
						});
					}
				}
				else {
					oldEnough();
				}

				const dateInputsAndSubmit = [$verifyMonth, $verifyDay, $verifyYear];
				dateInputsAndSubmit.forEach((input) => {
					input.on("keydown", function(e) {
						if (e.which === 13 || e.keyCode === 13) {
							e.preventDefault();
							checkDate();
						}
					});
				});
			}

			// Compares age entered with today's date 21 years ago...
			function oldEnough() {
				const birthDate = new Date(`${age.year}-${age.month}-${age.day}`);
				const currentDate = new Date();
				const timeDiff = currentDate.getTime() - birthDate.getTime();
				const timeByYearsDiff = timeDiff / (1000 * 60 * 60 * 24 * 365.25);
				if (parseFloat(timeByYearsDiff) >= 21) {
					$("#age-error-message").addClass("d-none");
					$.cookie("ageGateCookie", "oldEnough", { expires: 365, path: "/" });
					// saving age info for implementation in signup forms
					$.cookie("offsetBirthDay", parseInt(age.day), { expires: 14, path: "/" });
					$.cookie("offsetBirthMonth", age.month, { expires: 14, path: "/" });
					$.cookie("offsetBirthYear", age.year, { expires: 14, path: "/" });
					$offsetAgeGate.modal("hide");
					FIGURE.signUpAgeCookieFill();
					FIGURE.specialMessageModal();
				}
				else {
					$("#age-error-message").removeClass("d-none");
				}
			}
		}
		else {
			// $("#figureMessageModal").show();
			FIGURE.specialMessageModal();
		}
	});

	return true;
}();

FIGURE.signUpAgeCookieFill = function () {
	if ($("#signUp").length) {
		if ($.cookie("offsetBirthDay") && $.cookie("offsetBirthMonth") && $.cookie("offsetBirthYear")) {
			const month = $.cookie("offsetBirthMonth").toString();
			const monthInput = $("select[id=\"data\\[birth_month\\]\"]");
			const dayInput = $("select[id=\"data\\[birth_day\\]\"]");
			const yearInput = $("select[id=\"data\\[birth_year\\]\"]");
			monthInput.val(month);
			dayInput.val(parseInt($.cookie("offsetBirthDay")));
			yearInput.val($.cookie("offsetBirthYear"));
		}
	}
};

FIGURE.signUpAgeCookieFill();

FIGURE.SignUpPopulate = function() {
	if ($(".page-signup-dynamic").length || $(".page-signup-index").length) {
		const params = {};
		const queryString = window.location.search.substring(1); // Get the part after "?"
		const paramPairs = queryString.split("&"); // Split into key-value pairs

		paramPairs.forEach(pair => {
			const [key, value] = pair.split("=");
			if (key) params[decodeURIComponent(key)] = decodeURIComponent(value || "");
		});

		// Loop through each parameter and populate the form field if it exists
		$.each(params, function (key, value) {
			let set = { [key]: value };
			if (["name", "fullname", "full_name"].includes(key)) {
				// Split the name into first and last
				const firstLast = value.split(/ (.+)/);
				set = {
					first_name: firstLast[0],
					last_name: firstLast[1] || ""
				};
			}
			else if (["email", "email_address", "emailaddress"].includes(key)) {
				set = { username: value };
			}
			Object.keys(set).forEach(setKey => {
				const field = $(`[name="data[${setKey}]"]`);
				if (field.length) {
					field.val(set[setKey]);
				}
			});
		});
	}

	return true;
}();

FIGURE.mobileHorizontalWarningModal = function () {
	let warningModal = $(document).find("#mobileHorizontalWarning");
	$(window).on("load resize", function () {
		warningModal = $(document).find("#mobileHorizontalWarning");
		const isNarrowScreen = (window.innerWidth <= 767 && window.innerHeight <= 1200)
			|| (window.innerHeight <= 767 && window.innerWidth <= 1200);
		const isLandscape = window.innerWidth > window.innerHeight;
		const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
		const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		if (warningModal.length) {
			if (isNarrowScreen && isLandscape && isTouchDevice && isMobileUA) {
				if ($.cookie("mobileHorizontalWarning") !== "read") {
					warningModal.modal("show");
					$.cookie("mobileHorizontalWarning", "read", { expires: 1, path: "/" });
					setTimeout(() => {
						warningModal.modal("hide");
					}, 10000);
				}
			}
			else {
				warningModal.modal("hide");
			}
		}
	});

	return true;
}();

/**
* This is a function to show a second input after an option is selected on a sign up page
*/
FIGURE.referralSelect = function() {
	const $referralSourceSelect = $("#referralSourceSelect");
	const $referralText = $("#referraltext");
	if ($referralSourceSelect.length && $referralText.length) {
		$referralSourceSelect.change(function() {
			const theText = $(this).find(":selected").attr("data-message");
			if (!theText) {
				$referralText.addClass("d-none").attr("placeholder", "").attr("disabled", "disabled");
			}
			else {
				$referralText.removeClass("d-none").attr("placeholder", theText).removeAttr("disabled");
			}
		});
	}

	return true;
}();


/** Giftcard **/

FIGURE.giftCardValue = function(amount) {
	const dollars = amount;
	$(".gift-card-value-input").val(dollars);
	$(".gift-card-value").text(dollars);
};

FIGURE.formatNumber = function(n) {
	// format number 1000000 to 1,234,567
	return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

FIGURE.formatCurrency = function(input) {
	let input_val = input.val();
	if (input_val === "") {
		return;
	}
	// original length
	const original_len = input_val.length;
	// initial caret position
	let caret_pos = input.prop("selectionStart");
	// check for decimal
	let cleanNum = input_val.replace(".", "");
	cleanNum = cleanNum.replace(/[^0-9]/g, "");
	cleanNum = cleanNum.replace(/^0+/, "");
	input_val = FIGURE.formatNumber(cleanNum);
	// send updated string to input
	input.val(input_val);
	FIGURE.giftCardValue(input_val);
	// put caret back in the right position
	const updated_len = input_val.length;
	caret_pos = updated_len - original_len + caret_pos;
	input[0].setSelectionRange(caret_pos, caret_pos);
};

FIGURE.giftCards = function () {
	if ($(".page-giftcard-index").length) {
		const defaultVal = $(".gift-card-value-input").val();
		const $giftCardValueOptions = $(".gift-card-value-options");
		const option1 = $giftCardValueOptions.data("option-1");
		const option2 = $giftCardValueOptions.data("option-2");
		const option3 = $giftCardValueOptions.data("option-3");
		const options = [option1, option2, option3];
		const stripNumbers = (num) => {
			return parseFloat(num.replace("$", "").replace(",", ""));
		};
		const $giftCardValueBtnSelect = $(".gift-card-value-btn-select");
		$giftCardValueBtnSelect.removeClass("active");
		if (option1 && option2 && option3) {
			let isDefault = false;
			options.forEach((option) => {
				if (stripNumbers(defaultVal) === stripNumbers(option)) {
					$giftCardValueBtnSelect.each((_index, sel) => {
						const $giftCardValueBtnSelect = $(sel);
						if (stripNumbers($giftCardValueBtnSelect.val()) === stripNumbers(option)) {
							$giftCardValueBtnSelect.addClass("active");
							$(".gift-card-value-btn-custom").removeClass("active");
							isDefault = true;
						}
					});
				}
				else {
					$giftCardValueBtnSelect.each((_index, sel) => {
						const $giftCardValueBtnSelect = $(sel);
						if (stripNumbers($giftCardValueBtnSelect.val()) === stripNumbers(option)) {
							$giftCardValueBtnSelect.removeClass("active");
						}
					});
				}
			});
			if (!isDefault) {
				$giftCardValueBtnSelect.removeClass("active");
				const $giftCardValueBtnCustom = $(".gift-card-value-btn-custom");
				$giftCardValueBtnCustom.addClass("active");
				$giftCardValueBtnCustom.text(defaultVal);
			}
			$(document).on("click", ".gift-card-value-btn-select", function () {
				$(".gift-card-value-custom-input").removeClass("active");
				$(".gift-card-value-btn-custom").removeClass("active");
				$giftCardValueBtnSelect.removeClass("active");
				$(this).addClass("active");
				const thisValue = $(this).val();
				FIGURE.giftCardValue(thisValue);
				$("#collapseCustom").collapse("hide");
			});

			$(document).on("click", ".gift-card-value-btn-custom", function () {
				$giftCardValueBtnSelect.removeClass("active");
				const $giftCardValueBtnCustom = $(".gift-card-value-btn-custom");
				$giftCardValueBtnCustom.addClass("active");
				const $customAmount = $("#custom_amount");
				const value = $customAmount.val();
				const rawValue = parseFloat(value.replace("$", "").replace(",", ""));
				if (rawValue > 0) {
					FIGURE.giftCardValue(`$${value}`);
				}
				$customAmount.focus();
			});
		}
		$("input[data-type=\"currency\"]").on({
			keydown: function (e) {
				if (e.key === "Enter") {
					e.preventDefault();
				}
			},
			keyup: function (e) {
				FIGURE.formatCurrency($(this));
				if (e.key === "Enter") {
					$(this).trigger("blur");
				}
			},
			blur: function () {
				const $this = $(this);
				if ($this.hasClass("gift-card-value-custom-input")) {
					const val = parseFloat($this.val().replace("$", "").replace(",", "").replace(/^0+/, ""));
					FIGURE.formatCurrency($this);
					if (val === 0 || isNaN(val)) {
						const $giftCardValueBtnCustom = $(".gift-card-value-btn-custom");
						$giftCardValueBtnCustom.removeClass("active");
						$giftCardValueBtnCustom.text("Custom");
						$($giftCardValueBtnSelect[0]).trigger("click");
					}
					else if ($this.val()) {
						$giftCardValueBtnSelect.removeClass("active");
						$(".gift-card-value-custom-input").addClass("active");
						if (val > 2500) {
							$this.val("$2,500");
							FIGURE.giftCardValue("$2,500");
						}
						else if (val < 25) {
							$this.val("$25");
							FIGURE.giftCardValue("$25");
						}
						else {
							FIGURE.giftCardValue(`$${$this.val()}`);
						}
						const dollars = `$${$this.val()}`;
						const $giftCardValueBtnCustom = $(".gift-card-value-btn-custom");
						$giftCardValueBtnCustom.text(dollars);
						$giftCardValueBtnCustom.addClass("active");
					}
					$("#collapseCustom").collapse("hide");
				}
			}
		});
		const manualFormSubmit = async function() {
			const form = $("#giftCardSetUp");
			const action = form.attr("action");
			const formData = new FormData(form[0]);
			try {
				const res = await fetch(action, {
					method: "POST",
					body: formData,
				});
				if (res.status === 200) {
					window.location.href = res.url;
				}
				else {
					console.error("Something went wrong");
				}
			} catch (e) {
				console.error(e);
			}
		};
		$(document).on("submit", "#giftCardSetUp", function (e) {
			e.preventDefault();
		});
		$(document).on("click", "#submitGiftCard", function (e) {
			const value = parseFloat($(".gift-card-value-input").val().replace("$", "").replace(",", ""));
			if (value < 25 || value > 2500) {
				e.preventDefault();
				$(".less-than-five").show();
			}
			else {
				$(".less-than-five").hide();
				if (!$("#giftCardSetUp").hasClass("not-yet-sparky")) {
					$(document).find("#submitGiftCard").html("<div class=\"spinner-border\" style=\"width: 1.5rem; height: 1.5rem;\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>");
					manualFormSubmit();
				}
			}
		});

		$(window).on("load resize", function () {
			const customButtonHeight = $(".gift-card-value-btn-custom").outerHeight();
			$(".gift-card-value-custom-input").css({ height: customButtonHeight });
		});

		$("#giftCardBalanceModal").on("hide.bs.modal", function () {
			$("#giftCardCode").val("");
			grecaptcha.reset();
			$("#giftCardBalance").text("");
		});
	}

	return true;
}();

FIGURE.giftCardsBalance = function () {
	const runBalanceCheck = async function(code) {
		try {
			const action = `/giftcard/balance/${code}/`;
			const res = await fetch(action);
			const data = await res.json();
			if (data) {
				let amount = data.value;
				let cardActive = true;
				if ([null, false, 0].includes(amount)) {
					cardActive = false;
				}
				let balance = "";
				if (cardActive) {
					const splitAmount = amount.split(".");
					const formattedAmount = `${FIGURE.formatNumber(splitAmount[0])}.${splitAmount[1]}`;
					balance = `$${formattedAmount}`;
				}
				if (!cardActive) {
					balance = "Card Number Not Valid";
				}
				$(document).find("#giftCardBalance").html(balance);
			}
		} catch (error) {
			console.error(error);
		}
	};

	$(document).on("click", ".js-gift-card-check-balance", function() {
		const code = $(document).find("#giftCardCode").val();
		if (code) {
			$("#giftCardBalanceTitle").removeClass("d-none");
			$(document).find("#giftCardBalance").html("<div class=\"loading\"><div class=\"spinner-grow\" role=\"status\"><span class=\"sr-only\">Loading...</span></div></div>");
			setTimeout(() => {
				$(document).find("#giftCardBalance .loading").append("<div class=\"spinner-grow\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>");
			}, 100);
			setTimeout(() => {
				$(document).find("#giftCardBalance .loading").append("<div class=\"spinner-grow\" role=\"status\"><span class=\"sr-only\">Loading...</span></div>");
			}, 200);
			if (code === "123-test") {
				return;
			}
			runBalanceCheck(code);
		}
	});

	return true;
}();

FIGURE.applyCode = function() {
	$(document).on("click", "#jsApplyCodeAjax", function () {
		const $jsApplyCodeAjax = $(this);
		const theCode = $(".ajax-promo-code").val();
		const urlBase = (!!$jsApplyCodeAjax.data("url-base") && $jsApplyCodeAjax.data("url-base").trim().length)
			? $jsApplyCodeAjax.data("url-base").trim()
			: "cart";

		$.getJSON(`/${urlBase}/use-coupon-json/${theCode}/`, function(data) {
			if (data.success === true) {
				location.reload();
			}
			else if (data.gift_card_balance <= 0) {
				$(".promo-code-not-found").addClass("d-none");
				$(".promo-code-no-value").removeClass("d-none");
			}
			else {
				$(".promo-code-no-value").addClass("d-none");
				const $promoCodeNotFound = $(".promo-code-not-found");
				$promoCodeNotFound.removeClass("d-none");
				$promoCodeNotFound.find(".bad-promo-code").text(`${theCode} `);
			}
		});
		return false;
	});

	return true;
}();
